module.exports = __webpack_public_path__ + "img/mc-lr-r1-b1.b7c0aeee.gif";